/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message"];
import { getSenderId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUserId } from 'conversations-thread-data/auth/public/selectors';
import { deleteMessageInThread } from '../../thread-deletion/actions/deleteMessageInThread';
import { getCurrentThreadId } from 'conversations-thread-data/thread-details/public/selectors';
import { getCurrentThreadHistory } from 'conversations-thread-data/thread-histories/public/selectors/getCurrentThreadHistory';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getDeleteComment } from '../../usage-tracking/utils/threadInteraction';
import { jsx as _jsx } from "react/jsx-runtime";
export const withMessageDeletion = WrappedComponent => props => {
  const {
      message
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const dispatch = useDispatch();
  const threadId = useSelector(getCurrentThreadId);
  const userId = useSelector(getUserId);
  const threadHistory = useSelector(getCurrentThreadHistory);
  const handleClickToDelete = useCallback(() => {
    dispatch(deleteMessageInThread({
      threadId,
      messageId: getMessageId(message),
      threadHistory
    }));
  }, [dispatch, message, threadId, threadHistory]);
  const onClickToDeleteComment = useCallback(() => {
    trackEvent(getDeleteComment());
  }, []);
  const senderId = getSenderId(message);
  const canDeleteComment = senderId === userId;
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
    message: message
  }, rest, {
    handleClickToDelete: canDeleteComment ? handleClickToDelete : undefined,
    onClickToDeleteComment: canDeleteComment ? onClickToDeleteComment : undefined
  }));
};